import { render, staticRenderFns } from "./AccessControlTab.vue?vue&type=template&id=797e151e&scoped=true"
import script from "./AccessControlTab.vue?vue&type=script&lang=js"
export * from "./AccessControlTab.vue?vue&type=script&lang=js"
import style0 from "./AccessControlTab.vue?vue&type=style&index=0&id=797e151e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e151e",
  null
  
)

export default component.exports